








































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AdminUserWalletUpdateForm from '@/modules/wallet/components/admin/AdminUserWalletUpdateForm.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import WidgetClock from '@/modules/common/widgets/components/tools/WidgetClock.vue'
import WidgetQuote from '@/modules/common/widgets/components/tools/WidgetQuote.vue'
import WidgetCard from '@/modules/common/widgets/components/WidgetCard.vue'
import WidgetPhone from '@/modules/common/widgets/components/tools/WidgetPhone.vue'
import WidgetContainer from '@/modules/common/widgets/components/WidgetContainer.vue'

@Component({
  components: {
    WidgetContainer,
    WidgetPhone,
    WidgetCard,
    WidgetQuote,
    WidgetClock,
    BaseInput,
    AdminUserWalletUpdateForm
  }
})
export default class AdminDashboardContent extends Vue {
  imgAddressPopup: boolean = false
  imgAddress: string = null
  dark: boolean = localStorage.getItem('niknevis_dark') === '1'

  mounted() {
    //wallpaper
    this.imgAddress = localStorage.getItem('niknevis_img_url')
  }

  get defaultImgAddress() {
    return (this.dark)
      ? 'https://uploadkon.ir/uploads/260502_23uwp2609280.jpeg'
      : 'https://uploadkon.ir/uploads/ef6c02_234525846-mountains-minimalism-forest-firewatch.jpg'
    // ? 'https://s2.uupload.ir/files/b_irdb.jpg'
    // : 'https://s2.uupload.ir/files/a_g3d.jpg'
    // ? 'https://i.postimg.cc/vHtWXhJY/16697202145425177500259200876150.png'
    // : 'https://i.postimg.cc/7YHNFjMG/wallpaperflare-com-wallpaper-1.jpg'
    // ? 'https://i.postimg.cc/255WvfPv/b.jpg'
    // : 'https://i.postimg.cc/k4pBW6xP/a.jpg'
    // ? 'https://i.postimg.cc/BQCjhBG5/windows-11-microsoft-minimalism-digital-art-hd-wallpaper-e01035795f367ec338df8736eb964418.jpg'
    // : 'https://i.postimg.cc/gkbtzFdK/windows-10-windows-10x-windows-11-minimalism-material-minimal-hd-wallpaper-c5ef898a5eca0c1c821e44d7c.jpg'

  }

  get imgSrc() {
    return (!!this.imgAddress) ? this.imgAddress : this.defaultImgAddress
  }

  set imgSrc(value) {
    localStorage.setItem('niknevis_img_url', value)
    this.imgAddress = value
  }

  setNightMode() {
    this.dark = !this.dark
    localStorage.setItem('niknevis_dark', (this.dark === true) ? '1' : '0')
  }
}
